import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de29104471c1e1/components/sections/BranchSolutionsShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de29104471c1e1/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de29104471c1e1/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["KioskFAQ"] */ "/tmp/8de29104471c1e1/components/sections/KioskFAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de29104471c1e1/components/sections/UseCasesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/app/[locale]/branchen/shared-branch.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de29104471c1e1/node_modules/next/dist/client/link.js");
